import { PspContext } from "@/config/contexts";
import { useIsTablet } from "@/config/hooks";
import {
  getCookieConsent,
  getSelectedMandateId,
  setSelectedMandateIdStorage,
} from "@/config/utils";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getMandateById, getMyMandates } from "@/api/openapi";
import { toast } from "react-toastify";
import { translate } from "@/config/translator";

export function useLayout() {
  const isTablet = useIsTablet();
  const {
    lang,
    leftBarMobileOpen,
    setLeftBarMobileOpen,
    setSelectedMandate,
    setSelectedMandateId,
    setCookieConsentDialogOpen,
    setCookieConsentFunctionalOnly,
    selectedMandate,
  } = useContext(PspContext);
  useEffect(() => {
    if (selectedMandate?.id) {
      setSelectedMandateIdStorage(selectedMandate.id);
    }
  }, [selectedMandate?.id]);

  function getFirstMandate() {
    getMyMandates().then(({ data, error }) => {
      if (error) {
        toast(translate("somethingWentWrong", lang));
      } else {
        // context
        setSelectedMandate(data[0].mandate);
        setSelectedMandateId(data[0].mandate.id);

        // local storage

        setSelectedMandateIdStorage(data[0].mandate.id);
      }
    });
  }

  useEffect(() => {
    const mandateId = getSelectedMandateId();
    if (mandateId) {
      getMandateById({ path: { mandate_id: mandateId } }).then(
        ({ data, error }) => {
          if (error) {
            getFirstMandate();
          } else {
            setSelectedMandate(data);
            setSelectedMandateId(data.id);
          }
        },
      );
      return;
    }

    getFirstMandate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    lang,
    setCookieConsentDialogOpen,
    setCookieConsentFunctionalOnly,
    setSelectedMandate,
    setSelectedMandateId,
  ]);

  return {
    isTablet,
    leftBarMobileOpen,
    setLeftBarMobileOpen,
  };
}
